<template>
  <page-header
    :title-ch="titleCh"
    :title-en= "check(titleEn)"
    :breadcrumb-items="currentBreadcrumbItems"
  >
    <div class="light first mobile_hide" />
    <div class="light second" />
    <div class="light third" />
    <div class="light fourth mobile_hide" />
  </page-header>
</template>
<script>
import PageHeader from '~components/pages/Header'
export default {
  name: 'LecturesHeader',
  components: {
    PageHeader
  },
  props: {
    lectureType: {
      type: String,
      default: ''
    },
    titleCh: {
      type: String,
      default: ''
    },
    titleEn: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      lecturesBreadcrumb: [
        {
          text: '首頁',
          path: '/'
        },
        {
          text: this.titleCh,
          path: '/lectures/' + this.pathName(this.titleEn)
        }, {
          text: this.pathDetail(this.titleEn)
        }
      ]
    }
  },
  computed: {
    currentBreadcrumbItems () {
      return this.lectureType ? this.lecturesBreadcrumb : []
    }
  },
  methods: {
    check(i){
      switch (i) {
        case 'Recruitment Information Session':
          return i
        case 'Internship Information Session':
          return i
        default:
          return ""
      }
    },
    pathName (lecturesTypeEn) {
      switch (lecturesTypeEn) {
        case 'Lecture':
          return 'lecture'
        case 'Workshop':
          return 'workshop'
        case 'Recruitment Information Session':
          return 'recruitment'
        case 'Internship Information Session':
          return 'internship'
      }
    },
    pathDetail (lecturesTypeEn) {
      switch (lecturesTypeEn) {
        case 'Lecture':
          return '主題'
        case 'Workshop':
          return '主題'
        case 'Recruitment Information Session':
          return '公司'
        case 'Internship Information Session':
          return '公司'
      }
    }
  }
}
</script>
